export default __webpack_public_path__ + "static/media/BLR23.45ba1da0.jpg";